import Head from 'next/head';
import ImageBanner from '../components/ImageBanner';
import BannerTitle from '../components/BannerTitle';
import OnlineStore from '../container/OnlineStore';
import axios from 'axios';

const OnlineStorePage = ({products}) => {
  return (
    <div>
      <Head>
        <title>Shaking Crab | Store</title>
      </Head>
      <ImageBanner image='https://cdn.shakingcrab.com/website/images/DSC_2809.JPG'>
        <BannerTitle title='Online Shop' />
      </ImageBanner>
      <OnlineStore
        products={products}/>
    </div>
  );
};

// eslint-disable-next-line require-jsdoc
export async function getServerSideProps(context) {
  try {
    const API_V1 = process.env.NEXT_PUBLIC_API_V1;
    const getProductsUrl = API_V1 + 'products';
    const productsResp = await axios(getProductsUrl);
    const products = productsResp.data;
    return {
      props: {
        products,
      },
    };
  } catch (e) {
    console.error(e);
  }
  return {
    props: {
      products: [],
    },
  };
}

export default OnlineStorePage;
